export default __webpack_public_path__ + "static/media/ig-post-5.9bb0c627.jpeg";